import { categories } from './preSaveTransformers';

export const removeEmptySchema = ({ recipe }) => {
  categories.forEach((category) => {
    const categoryData = recipe[category[0]];
    categoryData?.[category[1]]?.forEach((cat) => {
      // Only remove schema if it's actually empty/null/undefined
      // Don't remove schemas that have content, even if it's just an empty string or "{}"
      if (cat?.schema === undefined || cat?.schema === null) {
        cat.schema = undefined;
      }
    });
  });
  return recipe;
};
